import axios from 'axios';
import { APP_VERSION } from '../../constants/endpoints';

export const PUT_APP_VERSION = 'PUT_APP_VERSION';

export const putAppVersion = (result) => {
  return {
    type: PUT_APP_VERSION,
    value: result,
  };
};

export const getAppVersion = async () => {
  try {
    const response = await axios.get(APP_VERSION);
    return response.data.value || '';
  } catch (error) {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/appVersionActions.js